import React, { useEffect, useState } from "react";
import { withAuthenticationRequired } from "../context/AuthContext";
import Loading from "../components/Loading";
import DateField from "../components/DateField";
import ReorderArrows from "../components/ReorderArrows";
import { useReorderableList } from "../utils/useReorderableList";
import { Button, MenuItem, Select, TextField } from "@mui/material";

import {
  BsFillArrowRightCircleFill,
  BsFillArrowLeftCircleFill
} from "react-icons/bs";
import { DataGrid } from "@mui/x-data-grid";
import { AddCircleOutline } from "@mui/icons-material";
import DeleteIcon from "@mui/icons-material/Delete";
import { useParams } from "react-router-dom";
import { restarUnDia, sumarUnDia } from "../utils/dates";
import { showSuccessMessage } from "../redux/appSlice";
import { useDispatch } from "react-redux";
import { useTypeThenRun } from "../utils/useTypeThenRun";
import { useRequestHandler } from "../utils/useRequestHandler";
import Servicios from "../services";

export const Programacion = () => {
  const { _tabladoId } = useParams();
  const [fecha, setFecha] = useState(new Date());
  const [textoBusquedaTmp, setTextoBusquedaTmp] = useState("");
  const [textoBusqueda, setTextoBusqueda] = useState("");
  const [conjuntos, setConjuntos] = useState([]);
  const [conjuntosActuan, setConjuntosActuan] = useState([]);
  const [tablados, setTablados] = useState([]);
  const [tabladoId, setTabladoId] = useState(_tabladoId);
  const [tablado, setTablado] = useState();
  const dispatch = useDispatch();
  const sendRequest = useRequestHandler();
  const [infoTitulo, setInfoTitulo] = useState("");
  const [infoDescripcion, setInfoDescripcion] = useState("");
  const [infoLinkEntradas, setInfoLinkEntradas] = useState("");

  const columnsConjuntos = [
    { field: "nombre", headerName: "Nombre", flex: 99 },
    {
      field: "actionAdd",
      headerName: "",
      sortable: false,
      align: "right",
      flex: 1,
      renderCell: params => {
        const onClick = e => {
          setConjuntos(
            conjuntos.map(x => {
              if (x.id == params?.row?.id) {
                setConjuntosActuan([...conjuntosActuan, x]);
                return { ...x, agregado: true };
              } else {
                return x;
              }
            })
          );
          setTextoBusqueda("");
          setTextoBusquedaTmp("");
        };

        return <AddCircleOutline className="action-icon" onClick={onClick} />;
      }
    }
  ];

  const {
    moveUp: moveConjuntoActuaUp,
    moveDown: moveConjuntoActuaDown,
    canMoveUp: canMoveConjuntoActuaUp,
    canMoveDown: canMoveConjuntoActuaDown
  } = useReorderableList(conjuntosActuan, setConjuntosActuan);

  const columnsConjuntosActuan = [
    { field: "nombre", headerName: "Nombre", flex: 99 },
    {
      field: "actionReorder",
      headerName: "",
      sortable: false,
      align: "right",
      flex: 2,
      renderCell: params => {
        const index = conjuntosActuan.indexOf(params.row);
        return (
          <ReorderArrows
            onMoveUp={() => moveConjuntoActuaUp(index)}
            onMoveDown={() => moveConjuntoActuaDown(index)}
            canMoveUp={canMoveConjuntoActuaUp(index)}
            canMoveDown={canMoveConjuntoActuaDown(index)}
          />
        );
      }
    },
    {
      field: "actionDelete",
      headerName: "",
      sortable: false,
      align: "right",
      flex: 1,
      renderCell: params => {
        const onClick = e => {
          setConjuntosActuan(
            conjuntosActuan.filter(x => x.id != params?.row?.id)
          );
        };

        return <DeleteIcon className="action-icon" onClick={onClick} />;
      }
    }
  ];

  useEffect(() => {
    sendRequest(Servicios.ObtenerTablados, [], data => {
      setTablados(data?.data);
    });
  }, []);

  useTypeThenRun(textoBusquedaTmp, () => setTextoBusqueda(textoBusquedaTmp));

  useEffect(() => {
    sendRequest(Servicios.ConjuntosConcursan, [textoBusqueda], data => {
      setConjuntos(
        data?.data.filter(z => !conjuntosActuan.map(x => x.id).includes(z.id))
      );
    });
  }, [textoBusqueda, conjuntosActuan]);

  useEffect(() => {
    if (tabladoId > 0) {
      sendRequest(
        Servicios.ObtenerProgramacionTablado,
        [tabladoId, new Date(fecha)],
        data => {
          setTablado(data?.data);
          setInfoTitulo(data?.data?.infoTitulo ?? "");
          setInfoDescripcion(data?.data?.infoDescripcion ?? "");
          setInfoLinkEntradas(data?.data?.infoLinkEntradas ?? "");
          setConjuntosActuan(data?.data?.conjuntos);
        }
      );
    }
  }, [tabladoId, fecha]);

  const handleGuardar = () => {
    sendRequest(
      Servicios.CargarProgramacionTablado,
      [
        {
          tabladoId,
          fecha: new Date(fecha),
          conjuntosId: conjuntosActuan.map(x => x.id),
          infoTitulo,
          infoDescripcion,
          infoLinkEntradas
        }
      ],
      () => {
        dispatch(showSuccessMessage("Programación cargada correctamente"));
      }
    );
  };

  return (
    <>
      <div className="card-modern">
        <div className="flex flex-wrap items-center my-3 justify-between gap-4">
          <div className="page-header">
            {tablado ? (
              <h4 className="page-title">Programación de tablado </h4>
            ) : (
              <h4 className="page-title">Seleccione un tablado</h4>
            )}
          </div>
          <div className="text-center">
            <Select
              style={{ width: 200 }}
              size="small"
              placeholder="Tablado"
              value={tabladoId}
              onChange={e => setTabladoId(e.target.value)}
            >
              {tablados?.map(c => (
                <MenuItem key={c.id} value={c.id}>
                  {c.nombre}
                </MenuItem>
              ))}
            </Select>
          </div>
          <div
            id="datepicker-programacion"
            className="datepicker text-end"
          >
            <div className="flex items-center gap-1">
              <div className="w-10">
                <BsFillArrowLeftCircleFill
                  className="m-2"
                  size={26}
                  onClick={() => setFecha(restarUnDia(fecha))}
                />
              </div>
              <div className="w-auto">
                <DateField
                  value={fecha}
                  onChange={setFecha}
                  ariaLabel="Fecha de programación"
                />
              </div>
              <div className="w-10">
                <BsFillArrowRightCircleFill
                  className="m-2"
                  size={26}
                  onClick={() => setFecha(sumarUnDia(fecha))}
                />
              </div>
            </div>
          </div>
        </div>
        <hr className="border-gray-200 dark:border-gray-700 my-4" />
        <div className="flex flex-col gap-3">
          <div className="mb-3">
            <TextField
              className="w-full"
              size="small"
              label="Título"
              value={infoTitulo}
              onChange={e => setInfoTitulo(e.target.value)}
            />
          </div>
          <div className="mb-3">
            <TextField
              className="w-full"
              size="small"
              label="Descripcion"
              multiline
              rows={3}
              value={infoDescripcion}
              onChange={e => setInfoDescripcion(e.target.value)}
            />
          </div>
          <div className="mb-3">
            <TextField
              className="w-full"
              size="small"
              label="Link entradas"
              value={infoLinkEntradas}
              onChange={e => setInfoLinkEntradas(e.target.value)}
            />
          </div>
        </div>
        <hr className="border-gray-200 dark:border-gray-700 my-4" />
        {tablado && (
          <>
            <div className="flex flex-col md:flex-row gap-4">
              <div className="w-full md:w-1/4">
                <div className="mb-3">
                  <TextField
                    className="w-full"
                    size="small"
                    label="Buscar conjunto"
                    value={textoBusquedaTmp}
                    onChange={e => setTextoBusquedaTmp(e.target.value)}
                  />
                </div>

                <div className="grid-wrapper" style={{ height: 400, overflow: "auto" }}>
                  <DataGrid
                    pagination={false}
                    disableColumnFilter
                    disableColumnMenu
                    disableDensitySelector
                    hideFooterPagination
                    rows={conjuntos}
                    columns={columnsConjuntos}
                    checkboxSelection={false}
                    className="no-header"
                  />
                </div>
              </div>
              <div className="w-full md:w-3/4 mt-3 md:mt-0">
                <div className="grid-wrapper" style={{ height: 400, overflow: "auto" }}>
                  <DataGrid
                    pagination={false}
                    disableColumnFilter
                    disableColumnMenu
                    disableDensitySelector
                    hideFooterPagination
                    rows={conjuntosActuan}
                    columns={columnsConjuntosActuan}
                    checkboxSelection={false}
                  />
                </div>
              </div>
            </div>
            <hr className="border-gray-200 dark:border-gray-700 my-4" />
            <div className="flex justify-between w-auto">
              <div className="text-start">
                <Button
                  variant={"outlined"}
                  onClick={() => {
                    window.history.go(-1);
                  }}
                >
                  Cancelar
                </Button>
              </div>
              <div className="text-end">
                <Button variant={"contained"} onClick={handleGuardar}>
                  Guardar
                </Button>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default withAuthenticationRequired(Programacion, {
  onRedirecting: () => <Loading />
});
